"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseSizeFromScreenWidth = void 0;
const config_1 = require("./config");
const DEFAULT_SIZE = 16;
const MOBILE_SIZE_SMALL = 15;
const MOBILE_SIZE_MEDIUM = 17;
const MOBILE_SIZE_LARGE = 19;
const getBaseSizeFromScreenWidth = () => {
    const { screenWidth } = config_1.config;
    if (screenWidth !== undefined) {
        if (screenWidth < 360) {
            return MOBILE_SIZE_SMALL;
        }
        if (screenWidth > 400 && screenWidth <= 700) {
            return MOBILE_SIZE_MEDIUM;
        }
        if (screenWidth > 700) {
            return MOBILE_SIZE_LARGE;
        }
    }
    return DEFAULT_SIZE;
};
exports.getBaseSizeFromScreenWidth = getBaseSizeFromScreenWidth;
